/*
 * Copyright (c) 2023 Bluemate B.V.
 */
import './style/historyImport.scss';

import React, {MouseEventHandler} from 'react';
import {useTranslation} from 'react-i18next';

import {ChangeFunction, Checkbox, CloseButton, NumberString} from '@dvrd/dvr-controls';

import IDate from '@dvrd/idate';

import {BluemateButton, BluemateInput, BluemateNumberInput, DvrdDatePicker} from '../../controls';

interface Props {
    onChangeImportDate: ChangeFunction<IDate | null>;
    onChangeInvNumPrefix: ChangeFunction<string>;
    onChangeInvNumStart: ChangeFunction<string>;
    onChangeSendEmails: ChangeFunction<boolean>;
    onChangeStartPage: ChangeFunction<NumberString>;
    onSubmit: MouseEventHandler;
    importTillDate: IDate | null;
    invNumPrefix: string;
    invNumStart: string;
    sendEmails: boolean;
    loading: boolean;
    startPage: number;
}

export default function HistoryImport(props: Props) {
    const {t} = useTranslation();
    const {
        importTillDate,
        onChangeImportDate,
        onChangeInvNumPrefix,
        invNumPrefix,
        invNumStart,
        onChangeSendEmails,
        onChangeInvNumStart,
        sendEmails,
        onSubmit,
        loading,
        onChangeStartPage,
        startPage
    } = props;

    function onClearImportDate() {
        onChangeImportDate(null);
    }

    const btnDisabled = !invNumPrefix.length || !invNumStart.length || loading;
    return (
        <section className='history-import'>
            <label className='section-title'>{t('admin.historyImport.settings', 'Instellingen')}</label>
            <div className='settings'>
                <div className='row date'>
                    <label>{t('admin.historyImport.orderFrom', '(Optioneel) Order importeren vanaf')}</label>
                    <DvrdDatePicker
                        onChange={onChangeImportDate}
                        value={importTillDate}
                        label=''
                        placeholder={t('admin.historyImport.datePlaceholder', 'dd-mm-jjjj')}
                        dateFormat='DD-MM-YYYY'
                        closeOnChange
                    />
                    {!!importTillDate && <CloseButton onClick={onClearImportDate} />}
                </div>
                <BluemateNumberInput
                    onChange={onChangeStartPage}
                    value={startPage}
                    label={t('admin.historyImport.firstPage', 'Eerste API page')}
                    wholeNumbers
                />
                <div className='row'>
                    <BluemateInput
                        onChange={onChangeInvNumPrefix}
                        value={invNumPrefix}
                        label={t('admin.historyImport.prefix', 'Voorvoegsel factuurnummer')}
                    />
                    <BluemateInput
                        onChange={onChangeInvNumStart}
                        value={invNumStart}
                        label={t('admin.historyImport.startNumber', 'Start factuurnummer')}
                    />
                </div>
                <Checkbox
                    onCheck={onChangeSendEmails}
                    checked={sendEmails}
                    label={t('admin.historyImport.sendEmails', 'E-mails verzenden')}
                />
                <BluemateButton
                    onClick={onSubmit}
                    label={t('admin.historyImport.start', 'Start')}
                    disabled={btnDisabled}
                />
            </div>
        </section>
    );
}
